import styled from 'styled-components';

import { Typography } from '../Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 0;
`;

export const Title = styled(Typography)`
  white-space: nowrap;
`;

export const Value = styled(Typography)`
  white-space: normal;
  margin-left: ${({ theme }) => theme.spacing.xxs};
`;
